/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */




 $(function() {
   $('.match-height').matchHeight();
 });



(function($) {

  $('#myCarousel').carousel({
interval: false
});

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        var site_url = $('.site_url').val();


        var looking_for = $('.looking-for');


        	if(looking_for.length > 0)
        	{
        		var parent_icon = '';
        		var choice_title = '';

        		// Do AJAX...
        		$.ajax(
        				{
        					type: 'GET',
        					url: site_url + 'lookingfor.php',
        					dataType: 'json',
        					cache: true,
        					success: function ( data )
        					{
        						// Hide Loader...
        						$('.loader').fadeOut(750,'swing',function()
        						{
        							$('.found-data').fadeIn();
        						});

        						$( data ).each(function( k, v )
        						{
        							//$('.found-data').append('<a class="looking-for__item" href="#" data-id="' + v.category_id + '" data-css-class="' + v.css_class +'" data-title="' + v.title + '"><span class="looking_for__icon -' + v.css_class +'"></span><span class="looking for__text">' + v.title + '</span></a>')
        							$('.found-data').append('<a class="looking-for__item" href="#" data-id="' + v.ID + '" data-css-class="' + v.post_name +'" data-title="' + v.post_title + '"><span class="looking_for__icon -' + v.post_name +'"></span><span class="looking for__text">' + v.post_title + '</span></a>')
        						});

        						// Bind Looking For Click...
        						looking_for_click();
        					}
        				}
        		)
        	}

        	function looking_for_click()
        	{
        		$('.looking-for__item').click(function()
        		{
        			$('.choice-part-one').fadeOut(750, 'swing', function()
        			{
        				$('.choice-part-two').fadeIn();
        			})

        			var id = $(this).data('id');
        			var title = $(this).data('title');
        			var css_class = $(this).data('css-class');
        			parent_icon = $(this).data('css-class');

        			if(css_class == 'mental-health')
        			{
        				setTimeout(function()
        				{
        					// Append Form...
        					$('.choice-form').append('<input class="' + css_class +'" name="pages[]" type="hidden" value="' + css_class +'">');
        					$('.choice-form').submit();
        				}, 800);
        			}
        			else
        			{
        				get_subcategories(id, function( data )
        				{
                  console.log(data);
        					if(data.length > 0)
        					{
        						var cat_id = data[0].ID;
        						var type = data[0].type;

        						if(type == 'question')
        						{
        							//choice_title = data[0].title;
        							choice_title = data[0].post_title;

        							$('.choice-title').html(choice_title);

        							get_subcategories(cat_id, function( response_data )
        							{
        								choice_title = 'Which Area of ' + title + '....?';

        								$( response_data ).each(function( k, v )
        								{
        									//$('.looking-for.-part-two').append('<a class="looking-for__subitem -' + v.css_class + '" href="#" data-id="' + v.category_id + '" data-css-class="' + v.css_class +'" data-title="' + v.title + '"><span class="looking for__text">' + v.title + '</span></a>')
        									$('.looking-for.-part-two').append('<a class="looking-for__subitem -' + parent_icon + '" href="#" data-id="' + v.ID + '" data-css-class="' + v.post_name +'" data-title="' + v.post_title + '"><span class="looking for__text">' + v.post_title + '</span></a>');
        								});

        								// Bind Sub Item Click....
        								sub_item_click();

        							});
        						}
        						else
        						{
        							choice_title = 'Which Area of ' + title + '....?';

        							$('.choice-title').html(choice_title);

        							get_subcategories(id, function( response_data )
        							{
        								choice_title = 'Which Area of ' + title + '....?';

        								$( response_data ).each(function( k, v )
        								{
        									//$('.looking-for.-part-two').append('<a class="looking-for__subitem -' + v.css_class + '" href="#" data-id="' + v.category_id + '" data-css-class="' + v.css_class +'" data-title="' + v.title + '"><span class="looking_for__icon -' + parent_icon +'"></span><span class="looking for__text">' + v.title + '</span></a>')
        									$('.looking-for.-part-two').append('<a class="looking-for__subitem -'+ v.ID +'" href="#" data-id="' + v.ID + '" data-page="' + v.post_name + '" data-css-class="' + v.post_name +'" data-title="' + v.post_title + '"><span class="looking_for__icon -' + parent_icon +'"></span><span class="looking for__text">' + v.post_title + '</span></a>')
        								});

        								// Bind Sub Item Click....
        								sub_item_click();

        							});
        						}
        					}
        					else
        					{
        						// No Data, Send To Page...
        						window.location.replace(site_url +'/service/'+ css_class);
        						return false;
        					}

        				});
        			}

        			$('.choice-form').append('<input type="hidden" name="area" value="' + css_class +'">');

        			return false;
        		})
        	}

        	function get_subcategories(id, callback)
        	{
        		// Do AJAX Call To Get Subs...
        		$.ajax(
        				{
        					type: 'GET',
        					url: site_url + 'lookingfor.php?subcategories='+ id,

        				}
        		).then (function(response) {
              // alert("success");
              callback (JSON.parse(response));
            }).catch (function (error) {
              alert ('error');
              console.log(error);
            })
        	}

        	function sub_item_click()
        	{
        		$('.looking-for__subitem').click(function()
        		{
        			var css_class = $(this).data('css-class');
        			var data_title = $(this).data('title');

        			if(css_class == 'yes')
        			{
        				choice_title = 'Please get in touch with one of our specialist solicitors';
        				$('.choice-title').html( choice_title );

        				// Hide Loader...
        				$('.looking-for.-part-two').fadeOut(750,'swing',function()
        				{
        					$('.contact-button').fadeIn();
        				});
        			}
        			else
        			{
        				var cat_id = $(this).data('id');

        				get_subcategories(cat_id, function( response_data )
        				{
        					if(data_title !== 'No')
        					{
        						if(response_data.length == 0)
        						{
        							choice_title = choice_title;
        						}
        						else
        						{
        							choice_title = 'Which Area of ' + data_title + '....?';
        						}
        					}

        					$('.choice-title').html( choice_title );

        					if( response_data.length !== 0 )
        					{
        						// Clear Looking For...
        						$('.looking-for.-part-two').html('');

        						$( response_data ).each(function( k, v )
        						{
        							//$('.looking-for.-part-two').append('<a class="looking-for__subitem -'+ v.page +'" href="#" data-id="' + v.category_id + '" data-page="' + v.page + '" data-css-class="' + v.page +'" data-title="' + v.title + '"><span class="looking_for__icon -' + parent_icon +'"></span><span class="looking for__text">' + v.title + '</span></a>')
        							$('.looking-for.-part-two').append('<a class="looking-for__subitem -'+ v.ID +'" href="#" data-id="' + v.ID + '" data-page="' + v.post_name + '" data-css-class="' + v.post_name +'" data-title="' + v.post_title + '"><span class="looking_for__icon -' + parent_icon +'"></span><span class="looking for__text">' + v.post_title + '</span></a>')
        						});

        						// Bind Sub Item Click....
        						sub_item_click();
        					}
        					else
        					{
        							var sub_item = $('.looking-for__subitem.-' + css_class);
        							if(sub_item.hasClass('-selected'))
        							{
        								$('input.' + css_class).remove();
        								$('.looking-for__subitem.-' + css_class).removeClass('-selected');
        							}
        							else
        							{
        								$('.looking-for__subitem.-' + css_class).addClass('-selected');

        								// Append Form...
        								$('.choice-form').append('<input class="' + css_class +'" name="pages[]" type="hidden" value="' + css_class +'">');
        								$('.choice-form').submit();

        								//$('.guidance-button').fadeIn();
        							}

        						return false;
        					}
        				});
        			}

        			return false;
        		})
        	}


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
